import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step2_1 from "@/assets/integration-steps/meta/step_2_1.png";
import step2_2 from "@/assets/integration-steps/meta/step_2_2.png";
import step2_3 from "@/assets/integration-steps/meta/step_2_3.png";

interface Props {
  stepLabel?: string;
}

const MetaIntegrationStep2 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step meta-step-2">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>Create a new customized audience</h6>
    </div>
    <div className="step-label-row">
      <p>
        Create a <b>new customized audience from the Audience manager</b>, with
        the data origin "Website".
      </p>
    </div>
    <img src={step2_1} alt="Screenshot of step 2.1 Meta Integration" />

    <hr />

    <img src={step2_2} alt="Screenshot of step 2.2 Meta Integration" />

    <hr />

    <img src={step2_3} alt="Screenshot of step 2.3 Meta Integration" />
  </div>
);

export default MetaIntegrationStep2;
